import React from 'react';
import { Link } from 'gatsby';

import BlogLayout from '../layout/blog';

import Feature from '../components/feature';
import Feed from '../components/feed';

// SEO imports
import SEO from '../components/seo';
import ogImage from '../assets/images/og-images/adaptix.jpg';

const BlogPage = () => (
	<BlogLayout>
		<SEO
			title="Blog | Strong Mind Performance Consulting"
			description="Read Strong Mind Performance Consulting's blog."
			image={ogImage}
		/>
		<section id="blog">
			<Feature />
			{/* <Feed /> */}
		</section>
	</BlogLayout>
);

export default BlogPage;
